export const anrufleitfadenObject = {
   absage: {
      id: "absage",
      type: "buttonNode",
      data: {
         frage: "Kein Problem, ich vermerke das wünsche Ihnen alles Gute, gern können Sie sich melden falls es zu Komplikationen kommt.",
         antworten: [{
               text: "Vermerken",
               weiter: false,
            },],
      },
      position: {
         x: 10000,
         y: 4000,
      },
   },
   termin: {
      id: "termin",
      type: "buttonNode",
      data: {
         frage: "Terminvereinbarung",
         antworten: [
            {
               text: "Termin vereinbaren",
               weiter: false,
            },
         ],
      },
      position: {
         x: 10000,
         y: 0,
      },
   },
   unterlagen: {
      id: "unterlagen",
      type: "buttonNode",
      data: {
         frage: "Das ist völlig in Ordnung, ich drücke IHnen die Daumen das der Verkauf für Sie gut klappt. Gern würden wir Ihnen unser kurze Broschüre zusenden.",
         antworten: [
            {
               weiter: false,
               text: "Entsprechende Unterlagen versenden und auf Vorlage setzen",
            },
         ],
      },
      position: {
         x: 10000,
         y: 2000,
      },
   },
   f0: {
      id: "f0",
      type: "buttonNode",
      data: {
         frage: "Hallo Herr/Frau [Nachname], ich hoffe, ich störe Sie nicht. Mein Name ist [Ihr Name] von BAUR Immobilien.\n        Ich habe Ihre Anzeige gesehen und wollte nachfragen ob die Wohnung/das Haus noch verfügbar ist?\n        Sie könnte gut zu einigen unserer Kunden passen die über uns eine Immobilie suchen?\n        Darf ich fragen, ob Sie sich schon Gedanken gemacht haben, ob die Zusammenarbeit mit einem Makler für Sie in Frage käme?",
         antworten: [
            {
               text: "Ich will keine Provision bezahlen darum mache ich es selber",
               weiter: "f0_0",
            },
            {
               text: "Ich möchte keinen Makler",
               weiter: "f0_1",
            },
            {
               text: "Wir haben bereits viele Interessenten",
               weiter: "f0_2",
            },
            {
               text: "Wir sind noch ganz am Anfang",
               weiter: "f0_3",
            },
            {
               text: "Wir wollen privat verkaufen",
               weiter: "f0_4",
            },
            {
               text: "Sie dürfen mich nicht anrufen?",
               weiter: "f0_5",
            },
            {
               text: "Haben Sie denn echte Kunden für meine Immobilie?",
               weiter: "f0_6",
            },
            {
               text: "Wenn Sie wirklich Suchkunden haben, können Sie mit denen kommen",
               weiter: "f0_7",
            },
            {
               text: "Ich will nicht das meine Käufer Provision bezahlen müssen!",
               weiter: "f0_8",
            },
            {
               text: "Die Immobilie ist schon verkauft",
               weiter: "f0_9",
            },
            {
               text: "Wir sprechen bereits mit einem anderen Makler",
               weiter: "f0_10",
            },
            {
               text: "Wir haben schon einen anderen Makler",
               weiter: "f0_11",
            },
            {
               text: "Die gleichen Kunden die sie haben sehen doch auch meine Anzeige",
               weiter: "f0_12",
            },
            {
               text: "Was unterscheidet Sie vonm anderen Maklern",
               weiter: "f0_13",
            },
            {
               text: "Was würde mir das bringen?",
               weiter: "f0_14",
            },
         ],
      },
      position: {
         x: 0,
         y: 0,
      },
   },
   f0_0: {
      id: "f0_0",
      type: "buttonNode",
      data: {
         frage: "Das kann ich verstehen, ich würde auch keine Provision bezahlen wollen. Aber was wäre wenn Ihnen anch Abzug aller Kosten mindestens der von Ihnen gewünschte Kaufpreis verbleibt oder Sie eventuell sogar mehr übrig hätten als Sie gedacht hätten?",
         antworten: [
            {
               text: "wie soll das denn gehen?",
               weiter: "f0_0_0",
            },
         ],
      },
      position: {
         x: 2000,
         y: 0,
      },
   },
   f0_0_0: {
      id: "f0_0_0",
      type: "buttonNode",
      data: {
         frage: "Wir haben als Makler schon den Anspruch das Sie als Verkäufer mindestens so gut fahren wie wenn Sie privat verkaufen oder soagr besser. Will heisse wenn wir Ihre Immobilie vermarkten sollten Sie einem Verkauf nur zustimmemn wenn der Kaufpreis der nach Abzug der Provision dem entsprciht zu dem Sie privat verkaufen würden. Sonst hätten Sie ja wenig Merhwert. Sicher interessant, dass Sie unsere Tätigkiet austesetn können, wir arbeiten ohne Vertrag und ohne Bindung Sie können unsere Arbeit testen udn wenn es nicht gefällt direkt wieder stoppen. Was ahlten Sie davon",
         antworten: [
            {
               text: "Wenn das so ist, können wir das gern näher besprechen",
               weiter: "termin",
            },
            {
               text: "Ich will das trotzdem nicht.",
               weiter: "unterlagen",
               ratgeber: "",
               frist: 14,
            },
         ],
      },
      position: {
         x: 4000,
         y: 0,
      },
   },
   f0_1: {
      id: "f0_1",
      type: "buttonNode",
      data: {
         frage: "Oh das ist schade. Haben Sie schon einmal schlechte Erfahrungen gemacht?",
         antworten: [
            {
               weiter: "f0_1_0",
               text: "Makler alle doof! ;-)",
            },
         ],
      },
      position: {
         x: 2000,
         y: 2050,
      },
   },
   f0_1_0: {
      id: "f0_1_0",
      type: "buttonNode",
      data: {
         frage: "Gern würden wir Ihnen zeigen das ein Makler durchaus auch sehr nüzlich sein kann für den Verkauf. Wäre es nicht ein Versuch wert zu schauen was wir für Sie tun können ohne das Sie sich zu etwas verpflichten? Zum einen können Sie weiterhin privat verkaufen zum anderen können Sie unsere Bemühungen direkt stoppen wenn Sie keinen Mehrwert sehen.",
         antworten: [
            {
               weiter: "unterlagen",
               text: "Nein ich will nicht!",
               ratgeber: "",
               frist: 14,
               ratgeberText:
                  "Das ist völlig in Ordnung, ich drücke IHnen die Daumen das der Verkauf für Sie gut klappt. Gern würden wir Ihnen unser kurze Broschüre zum privaten Immobilienverkauf zusenden.",
            },
            {
               weiter: "termin",
               text: "Na gut",
            },
         ],
      },
      position: {
         x: 4000,
         y: 2050,
      },
   },
   f0_2: {
      id: "f0_2",
      type: "buttonNode",
      data: {
         frage: "Das freut mich und wundert mich nicht. Woran scheitert es bisher?",
         antworten: [
            {
               weiter: "f0_2_0",
               text: "Diverse Dinge, die Kunden haben etwas auszusetzten, Finanzierungen klappen nicht usw.",
            },
            {
               weiter: "f0_2_1",
               text: "Wir sind ganz am Anfang, wir wollen mal schauen was passiert",
            },
            {
               weiter: "unterlagen",
               text: "So wie es aussieht sind Kunden in der finalen Entscheidung, wir rechnen bald mit einer Zusage.",
               ratgeber: "",
               ratgeberText:
                  "Das freut mich sehr, ich drücke Ihnen die Daumen. Haben Sie bereits alles Unterlagen zusammengestellt die Sie dem Käufer geben sollten? ich sende Ihnen gern unsere Aufstellung zu. Dort finden Sie alle Unterlagen die Sie dringend vorlgien haben soltlen. Sie wissen das Sie bei der Finanzierung derzeit sehr gut aufpassen müssen, Sie sollten nicht beurkunden bevor Sie die Grundschuldbestellung vorliegen haben. Soll ich Ihnen unseren kurzen Leitfaden zuschicken? Da sind einige wertvolle Hinweise drin.",
               frist: 14,
            },
            {
               weiter: "f0_2_3",
               text: "Wir haben schon einen Interessenten der kaufen will.",
            },
         ],
      },
      position: {
         x: 2000,
         y: 4100,
      },
   },
   f0_2_0: {
      id: "f0_2_0",
      type: "buttonNode",
      data: {
         frage: "Das kennen wir gut. Das kann ganz schon nervenaufreibend sein. Da könnten wir Ihnen einiges an Stress und Aufregung abnehmen. Wäre es nicht angenehm sich zurückzulehen und andere die Arbeit tun zu lassen?",
         antworten: [
            {
               weiter: "f0_2_0_0",
               text: "Schon....diverse Frage zu Provision und Ablauf",
            },
            {
               weiter: "f0_2_0_1",
               text: "Wir wollen es erst mal noch eine Weile versuchen",
            },
         ],
      },
      position: {
         x: 4000,
         y: 4100,
      },
   },
   f0_2_0_0: {
      id: "f0_2_0_0",
      type: "buttonNode",
      data: {
         frage: "Das erkläre ich Ihnen alles gern bei einem kurzen Kennenlernen. Wann würde es denn ei Ihnen  passen, das wir uns mal kurz unverbildich treffen?",
         antworten: [
            {
               weiter: "termin",
               text: "Terminvereinbarung",
            },
         ],
      },
      position: {
         x: 6000,
         y: 0,
      },
   },
   f0_2_0_1: {
      id: "f0_2_0_1",
      type: "buttonNode",
      data: {
         frage: "Das kann ich verstehen, darf ich Ihnen unseren kurzen Ratgeber zusenden auf was zu achten ist beim Immobilienverkauf?",
         antworten: [
            {
               weiter: "unterlagen",
               text: "unterlagen",
               ratgeber: "",
               frist: 8,
            },
         ],
      },
      position: {
         x: 6000,
         y: 2050,
      },
   },
   f0_2_1: {
      id: "f0_2_1",
      type: "buttonNode",
      data: {
         frage: "Das kann ich gut verstehn. Wie ist denn bisher der Verlauf?",
         antworten: [
            {
               weiter: "f0_2_1_0",
               text: "egal ob der Kunde hier gut oder schlecht sagt....",
            },
         ],
      },
      position: {
         x: 4000,
         y: 6150,
      },
   },
   f0_2_1_0: {
      id: "f0_2_1_0",
      type: "buttonNode",
      data: {
         frage: "BIs wann möchten Sie denn den Verkauf abgewickelt haben?",
         antworten: [
            {
               weiter: "f0_2_1_0_0",
               text: "eher kurzfristig",
            },
            {
               weiter: "unterlagen",
               text: "keine Eile",
               ratgeber: "privater Immobilienverkauf",
               frist: 14,
            },
         ],
      },
      position: {
         x: 6000,
         y: 4100,
      },
   },
   f0_2_1_0_0: {
      id: "f0_2_1_0_0",
      type: "buttonNode",
      data: {
         frage: "Wäre es da nicht wert nochmal drüber nachzudenken zusätlziche Hilfe von uns in Anspruch zu nehmen?",
         antworten: [
            {
               weiter: "unterlagen",
               text: "nein wie gesagt, wir versuchen es erst selber",
               ratgeber: "privater Immobilienverkauf",
               frist: 14,
            },
            {
               weiter: "termin",
               text: "ja gut, vielleicht doch?",
            },
         ],
      },
      position: {
         x: 8000,
         y: 0,
      },
   },
   f0_2_3: {
      id: "f0_2_3",
      type: "buttonNode",
      data: {
         frage: "Das freut mich sehr, ich drücke Ihnen die Daumen. Haben Sie bereits alles Unterlagen zusammengestellt die Sie dem Käufer geben sollten? ich sende Ihnen gern unsere Aufstellung zu. Dort finden Sie alle Unterlagen die Sie dringend vorlgien haben soltlen. Sie wissen das Sie bei der Finanzierung derzeit sehr gut aufpassen müssen, Sie sollten nicht beurkunden bevor Sie die Grundschuldbestellung vorliegen haben. Soll ich Ihnen unseren kurzen Leitfaden zuschicken? Da sind einige wertvolle Hinweise drin.",
         antworten: [
            {
               weiter: "f0_2_3_0",
               text: "Brauche ich nicht",
            },
            {
               weiter: "f0_2_3_1",
               text: "Gern senden Sie mir die Unterlagen gern zu.",
            },
         ],
      },
      position: {
         x: 4000,
         y: 8200,
      },
   },
   f0_2_3_0: {
      id: "f0_2_3_0",
      type: "buttonNode",
      data: {
         frage: "Gibt es schon einen Termin zur Beurkundung?",
         antworten: [
            {
               weiter: "unterlagen",
               text: "Ja, in x Tagen",
               ratgeber: "Notarielle Abwicklung",
               frist: false,
               ratgeberText:
                  "Das ist sehr gut, ich drücke die Daumen. Finazierung ist gesichert nehme ich an? Darf ich Ihnen unseren Ratgeber zusenden auf was zu achten ist bei der notariellen Abwicklung?",
            },
            {
               weiter: "f0_2_3_0_0",
               text: "Nein noch nicht",
            },
         ],
      },
      position: {
         x: 6000,
         y: 6150,
      },
   },
   f0_2_3_0_0: {
      id: "f0_2_3_0_0",
      type: "buttonNode",
      data: {
         frage: "Gibt es einen Grund für so eine lange Wartezeit. Wir empfehlen eigentlich immer eine rasche Beurkundung wenn der Käufer sich entschieden hat. Oder macht der Käufer den Kaufvertrag noch von irgendwas abhängig? (z.B. Finanzierung oder Begehung mit dem Gutachter)",
         antworten: [
            {
               weiter: "f0_2_3_0_0_0",
               text: "Diverse Gründe, z.B. noch kein Termin vereinbart, Käufer hat noch keine finale Finanzierung usw.",
            },
         ],
      },
      position: {
         x: 8000,
         y: 2050,
      },
   },
   f0_2_3_0_0_0: {
      id: "f0_2_3_0_0_0",
      type: "buttonNode",
      data: {
         frage: "Dar ich Ihen eine Ratschlag geben? Wenn Ihr Käufer nicht binnen von max 14 Tagen bereit ist zum Notar zu gehen, gleich aus welchen Gründen, ist er nach unserer Interpretation nur ein Interessent. Da Sie ihn keinesfalls binden können ist es fraglich ob ein Interessent nach längere Zeit überhaupt noch kaufen möchte. Haben Sie sich denn eine Deadline gesetzt bis wann Sie beurkunden möchten?",
         antworten: [
            {
               weiter: "unterlagen",
               text: "Ja bis zum....",
               ratgeber: "",
               ratgeberText:
                  "Das ist gut, darf ich Ihnen unseren kurzen Ratgeber schicken auf was zu achten ist? Dort sind sicher einige wertvolle Infos für Sie dabei? Ratgeber versenden und WV bis Maximal ein paar Tage VOR dem Notartermin",
            },
            {
               weiter: "unterlagen",
               text: "Nein, er braucht noch eine Weile...",
               ratgeber: "",
               ratgeberText:
                  "Wenn ich Ihnen ein Rat geben darf, fragen Sie Ihn nach einem fixen Termin für eine Beurkundung. Wenn Ihnn den nicht nenn kann oder will, sollten Sie Ihre Verkaufsbemühungen nicht stoppen. Darf ich Ihnen unseren kurzen Ratgeber schicken auf was zu achten ist? Dort sind sicher einige wertvolle Infos für Sie dabei?",
               frist: 14,
            },
         ],
      },
      position: {
         x: 8000,
         y: 4100,
      },
   },
   f0_2_3_1: {
      id: "f0_2_3_1",
      type: "buttonNode",
      data: {
         frage: "Gern, für wann haben Sie denn den notariellen Kaufvertrag geplant?",
         antworten: [
            {
               weiter: "f0_2_3_1_0",
               text: "Noch gar nicht?",
            },
            {
               weiter: "f0_2_3_1_1",
               text: "in x Wochen",
            },
            {
               weiter: "unterlagen",
               text: "Das will ich Ihnen nicht sagen",
               ratgeber: "",
               frist: 14,
               ratgeberText:
                  "Entschuldigen Sie ich wollte nicht indiskret sein. Ich sende Ihnen den Ratgeber einfach mal zu. Gern höre ich von Ihnen wenn wir vielleicht doch was für Sie tun können?",
            },
            {
               weiter: "unterlagen",
               text: "zeitnaher fester Termin",
               ratgeber: "Finanzierung",
               frist: false,
               ratgeberText:
                  "Das ist sehr gut, ich drücke die Daumen. Finazierung ist gesichert nehme ich an? Darf ich Ihnen unseren Ratgeber zusenden auf was zu achten ist bei der notariellen Abwicklung? Vorlage kurz nach Notartermin (1 Tag)",
            },
         ],
      },
      position: {
         x: 6000,
         y: 8200,
      },
   },
   f0_2_3_1_0: {
      id: "f0_2_3_1_0",
      type: "buttonNode",
      data: {
         frage: "Oh, warum nicht, hängt die endgültige Entscheidung noch von etwas ab (z.B. Finanzierung des Käufers?)",
         antworten: [
            {
               weiter: "f0_2_3_0_0_0",
               text: "Diverse Gründe, z.B. noch kein Termin vereinbart, Käufer hat noch keine finale Finanzierung usw.",
            },
         ],
      },
      position: {
         x: 8000,
         y: 6150,
      },
   },
   f0_2_3_1_1: {
      id: "f0_2_3_1_1",
      type: "buttonNode",
      data: {
         frage: "Gibt es einen Grund für so eine lange Wartezeit. Wir empfehlen eigentlich immer eine rasche Beurkundung wenn der Käufer sich entschieden hat. Oder macht der Käufer den Kaufvertrag noch von irgendwas abhängig? (z.B. Finanzierung oder Begehung mit dem Gutachter)",
         antworten: [
            {
               weiter: "f0_2_3_0_0_0",
               text: "Diverse Gründe, z.B. noch kein Termin vereinbart, Käufer hat noch keine finale Finanzierung usw.",
            },
         ],
      },
      position: {
         x: 8000,
         y: 8200,
      },
   },
   f0_3: {
      id: "f0_3",
      type: "buttonNode",
      data: {
         frage: "Das habe ich gesehen, wie läuft es bisher, gibt es viele Anfragen?",
         antworten: [
            {
               weiter: "unterlagen",
               text: "So wie es aussieht sind Kunden in der finalen Entscheidung, wir rechnen bald mit einer Zusage.",
               ratgeber: "",
               ratgeberText:
                  "Das freut mich sehr, ich drücke Ihnen die Daumen. Haben Sie bereits alles Unterlagen zusammengestellt die Sie dem Käufer geben sollten? ich sende Ihnen gern unsere Aufstellung zu. Dort finden Sie alle Unterlagen die Sie dringend vorlgien haben soltlen. Sie wissen das Sie bei der Finanzierung derzeit sehr gut aufpassen müssen, Sie sollten nicht beurkunden bevor Sie die Grundschuldbestellung vorliegen haben. Soll ich Ihnen unseren kurzen Leitfaden zuschicken? Da sind einige wertvolle Hinweise drin.",
               frist: 14,
            },
            {
               weiter: "f0_2_3",
               text: "Wir haben schon einen Interessenten der kaufen will.",
            },
            {
               weiter: "f0_3_0",
               text: "ist noch nicht abzusehen/ist wenig",
            },
         ],
      },
      position: {
         x: 2000,
         y: 6150,
      },
   },
   f0_3_0: {
      id: "f0_3_0",
      type: "buttonNode",
      data: {
         frage: "Ich würde Ihnen gern anbieten mal die Immobilien anzuschauen und auch nochmal eine kurze Wertanalyse zu erstellen, die Sie ggfs auch für Ihren privaten Verkauf verwenden können",
         antworten: [
            {
               weiter: "termin",
               text: "Termin",
            },
            {
               weiter: "unterlagen",
               ratgeber: "",
               frist: 14,
               ratgeberText:
                  "Kein Problem, was ich Ihnen trotzdem ans Herz legen würde, wir haben eine tolle Broschüre für privatre Eigentümer die viele Tipps und vor allem Hinweise enthält wie man Risiken vermeidet, darf ich Ihnen die zuschicken?",
               text: "Nein das möchte ich derzeit nicht",
            },
         ],
      },
      position: {
         x: 4000,
         y: 10250,
      },
   },
   f0_4: {
      id: "f0_4",
      type: "buttonNode",
      data: {
         frage: "Das kann ich gut verstehen. Das ist aber geade des Besondere bei BAUR Immobilien. Wir bieten Ihnen unsere volle Unterstützung an und Sie können trotzdem weiterhin privat verkaufen. Bei uns gibt es keine Bindung oder Exclusivität. Sie erweiteren lediglich Ihre Möglichkeiten.",
         antworten: [
            {
               weiter: "f0_4_0",
               text: "Das mag sein, aber wir wollen trotzdem privat verlaufen",
            },
         ],
      },
      position: {
         x: 2000,
         y: 8200,
      },
   },
   f0_4_0: {
      id: "f0_4_0",
      type: "buttonNode",
      data: {
         frage: "Wie gesagt, das könnten Sie bei einer Zusammenarbeit immer noch tun, da wir Sie nicht einschränken, sie würden nur Ihre Möglichkeiteen vervielfachen wenn auch unsere Kunden Gelegeheit hätten Ihre Immobilie kennzulernen? Wäre es nicht schade diese Chance nicht zu nutzen?",
         antworten: [
            {
               weiter: "termin",
               text: "na gut",
            },
            {
               weiter: "f0_",
               text: "Nein",
               ratgeber: "privater Immobilienverkauf",
               frist: 14,
               ratgeberText:
                  "Völlig in Ordnung, in dem Fall drück ich Ihnen die Daumen, sicherlich findet sich jemand für diese Immobilie. Darf ich Ihnen trotzdem unseren kurzen Ratgeber 'Privater Immobilienverkauf' übersenden?",
            },
         ],
      },
      position: {
         x: 4000,
         y: 12300,
      },
   },
   f0_5: {
      id: "f0_5",
      type: "buttonNode",
      data: {
         frage: "Sie meinen das Gesetz zum unlauteren Wettbewerb? Da haben Sie grundsätzlich völlig recht. Kaltakquiseanrufe sind verboten. Wir rufen allerdings auf Ihr Angebot an, das für viele unserer Kunden die uns mit der Suche nach Immobilien beauftragt haben passen könnte. Selbstverständlich müssen Sie nicht mit uns reden und ich mache gern einen Vermerk das wir Sie nicht kontaktieren sollen. Entchuldigen Sie bitte wenn unser Anruf unerwünscht war.",
         antworten: [
            {
               weiter: "absage",
               text: "Ich  möchte aber nicht kontaktiert werden",
            },
            {
               weiter: "f0_6",
               text: "Haben Sie denn echte Kunden?",
            },
         ],
      },
      position: {
         x: 2000,
         y: 10250,
      },
   },
   f0_6: {
      id: "f0_6",
      type: "buttonNode",
      data: {
         frage: "Wir haben in der Region schon einige Immobilien verkauft und bieten auch derzeit einige Immobilien an. Aus den vielen Interessenten haben sich etliche aktuelle Suchaufträge ergeben. Aber wir würden uns ie Immobilie auf jeden Fall gern erst mit Ihnen gemeinsam anschauen bevor wir Sie unseren Kunden anbieten.",
         antworten: [
            {
               weiter: "f0_6_0",
               text: "Dashab ich mir schon gedacht, Sie haben wohl keine echte Kunden, das sagen alle Makler",
            },
            {
               weiter: "termin",
               text: "Anschauen können Sie die Immobilie mal, aber ich unterschreibe nichts",
            },
         ],
      },
      position: {
         x: 2000,
         y: 12300,
      },
   },
   f0_6_0: {
      id: "f0_6_0",
      type: "buttonNode",
      data: {
         frage: "Ich kann nicht für die Kollegen sprechen, aber wenn Sie mal auf unsere Homepage schauen möchten, da sehen Sie das wir regelmässig in Ihrer Region verkaufen. Die meisten unserer Interessenten hinterlassen bei uns einen Suchwunsch der immer ob er noch aktuell ist. Ihre Immobilie würde auf viele der Suchwünsche passen. Gern würde ich Sie mir anschauen um Sie unverbindlich unseren Kunden anzubieten?",
         antworten: [
            {
               weiter: "termin",
               text: "na gut",
            },
            {
               weiter: "f0_8_0_0",
               text: "Nein, das will ich nicht",
            },
         ],
      },
      position: {
         x: 4000,
         y: 14350,
      },
   },
   f0_7: {
      id: "f0_7",
      type: "buttonNode",
      data: {
         frage: "Wir würden uns die Immobilie zuerst gern anschauen, bevor wir Sie unseren Kunden anbieten. Eine Immobilien unseren Kunden anzubeitend ie wir selbst nicht persönlich gesehen haben entspricht nicht unserer Arbeitsweise und wäre nicht sehr seriös.",
         antworten: [
            {
               weiter: "f0_6_0",
               text: "Dashab ich mir schon gedacht, Sie haben wohl keine echte Kunden, das sagen alle Makler",
            },
            {
               weiter: "termin",
               text: "Anschauen können Sie die Immobilie mal, aber ich unterschreibe nichts",
            },
         ],
      },
      position: {
         x: 2000,
         y: 14350,
      },
   },
   f0_8: {
      id: "f0_8",
      type: "buttonNode",
      data: {
         frage: "Das kann ich absolut verstehen. Niemand zahlt gern Provision. Aber es gibt sehr viele Käufer die auf einen Makler setzen und ganz bewusst über den Makler gehen, so wie die vielen 1000 Suchkunden die wir haben. Wäre es nicht schade, wenn Sie diese Chance nicht zusätlzich nutzen würden? Im Übrigen können Sie bei einer Zusammenarbeit mit uns Ihre Immobilie sogar weiterhin privat verkaufen wenn sich noch ein Interessetn aus Ihrer Ausschreibung zum Kuaf entschliessen sollte.",
         antworten: [
            {
               weiter: "termin",
               text: "Ja, Termin",
            },
            {
               weiter: "f0_8_0",
               text: "Das interessiert micht nicht, ich will nicht mit einem Makler arbeiten",
            },
         ],
      },
      position: {
         x: 2000,
         y: 16400,
      },
   },
   f0_8_0: {
      id: "f0_8_0",
      type: "buttonNode",
      data: {
         frage: "Das ist wirkich sehr schade, gibt es etwas das ich tun kann um Sie vielleicht doch von den Vorteilen zu begeistern?",
         antworten: [
            {
               weiter: "f0_8_0_0",
               text: "Nein, auf keinen Fall!",
            },
         ],
      },
      position: {
         x: 4000,
         y: 16400,
      },
   },
   f0_8_0_0: {
      id: "f0_8_0_0",
      type: "buttonNode",
      data: {
         frage: "Gut das werde ich schweren Herzens akzeptieren müssen. Darf ich Ihnen trotzdem per Mail unseren kleinen Ratgeber auf was man achten sollte beim Verkauf zukommen lassen?",
         antworten: [
            {
               weiter: "unterlagen",
               text: "Ja von mir aus",
               ratgeber: "",
               frist: 14,
            },
            {
               weiter: "absage",
               text: "nein",
            },
         ],
      },
      position: {
         x: 6000,
         y: 10250,
      },
   },
   f0_9: {
      id: "f0_9",
      type: "buttonNode",
      data: {
         frage: "Das freut mich sehr für Sie. Sind Sie mit dem Verkauf des Verkaufes und dem Preis zufrieden?.... Hat der Notertemin schon stattgefunden?",
         antworten: [
            {
               weiter: "f0_9_0",
               text: "ja",
            },
         ],
      },
      position: {
         x: 2000,
         y: 18450,
      },
   },
   f0_9_0: {
      id: "f0_9_0",
      type: "buttonNode",
      data: {
         frage: "Das freut micht sehr für Sie, ich gratuliere. Darf ich Ihnen unseren kurzen Ratgeber zusenden auf was man achten soll zur Abwicklung?",
         antworten: [
            {
               weiter: "unterlagen",
               text: "ja",
               ratgeber: "",
               ratgeberText: "Entsprechende Unterlagen versenden und als gescheitert ablegen",
            },
            {
               weiter: "absage",
               text: "nein",
            },
         ],
      },
      position: {
         x: 4000,
         y: 18450,
      },
   },
   f0_10: {
      id: "f0_10",
      type: "buttonNode",
      data: {
         frage: "Das ist genau richtig. Und Sie sollten nicht nur mit einem Makelr sprechen. Vergleichen Sie uns und entscheiden Sie ganz gelassen welcher Makler zu Ihnen passt",
         antworten: [
            {
               weiter: "termin",
               text: "Gerne, Terminvereinbarung",
            },
            {
               weiter: "f0_10_0",
               text: "nein, das uns reicht erst mal einer?",
            },
         ],
      },
      position: {
         x: 2000,
         y: 20500,
      },
   },
   f0_10_0: {
      id: "f0_10_0",
      type: "buttonNode",
      data: {
         frage: "Das sprciht für Sie, aber ich kann es Ihnen nur anraten und anbieten. Nur im Vergleich werden Sie sich sicher sein können ob Sie den richtigen Makler für Ihre Situation haben. Wann dürfte ich denn mal vorbeikommen?",
         antworten: [
            {
               weiter: "termin",
               text: "Gerne, Terminvereinbarung",
            },
            {
               weiter: "unterlagen",
               text: "Lassen Sie es, ich will keinen Vergleich",
               ratgeber: "",
               frist: 14,
               ratgeberText:
                  "Das ist sehr schade aber völlig in Ordung. Darf ich Ihnen trotzden unseren Ratgeber 'Privater Immobilienverkauf' mit vielen Tipps und Tricks senden?",
            },
         ],
      },
      position: {
         x: 4000,
         y: 20500,
      },
   },
   f0_11: {
      id: "f0_11",
      type: "buttonNode",
      data: {
         frage: "Das ist grundsätzlich gut, wie läuft es bisher",
         antworten: [
            {
               weiter: "unterlagen",
               text: "ganz zufrieden",
               ratgeber: "",
               ratgeberText: "das freut mich, ich werde das neugierig verfolgen, ich drücke Ihnen die Daumen",
               frist: 28,
            },
            {
               weiter: "f0_11_0",
               text: "unzufrieden",
            },
         ],
      },
      position: {
         x: 2000,
         y: 22550,
      },
   },
   f0_11_0: {
      id: "f0_11_0",
      type: "buttonNode",
      data: {
         frage: "Wie lange sind Sie noch gebunden, bzw. kommen Sie aus dem Vertrag heraus?",
         antworten: [
            {
               weiter: "termin",
               text: "Kurzfristig",
            },
            {
               weiter: "unterlagen",
               text: "Langfristig",
               ratgeber: "",
               ratgeberText:
                  "Achten Sie darauf, dass der vertrag sich nicht automatisch verlängert, auf wann kommen Sie denn raus? Wiedervorlage je nach Dauer, maximal bis 4 Wochen vor ablauf",
            },
         ],
      },
      position: {
         x: 4000,
         y: 22550,
      },
   },
   f0_12: {
      id: "f0_12",
      type: "buttonNode",
      data: {
         frage: "Das ist natürlich grundsätzlich richtig, aber zum einen können wir über das Portal trotz gleicher technischer Daten allein über die zielgruppenorientierte Ausschreibung durch unsere Marketing eine ganz ander Quantität an Interessenten erreichen. Zudem erreichen wir weiter eine deutlich größere Anzahl an Interessenten durch die Ausschreibung auf allen Portalen. Ein wichtiger Punkt sind die Synergieeffekte die wir aufrgund unserer vielen Besichtigungen haben. D.h. wir können unseren Interessenten die sich z.B: eine andere Whg angeschuat haben Ihre Whg proaktiv anbieten.",
         antworten: [
            {
               weiter: "f0",
               text: "Je nach Antwort am Leitfaden anknüpfen",
            },
         ],
      },
      position: {
         x: 2000,
         y: 24600,
      },
   },
   f0_13: {
      id: "f0_13",
      type: "buttonNode",
      data: {
         frage: "BAUR Immobilien – Ihre flexible, risikofreie Lösung\n30 Jahre Erfahrung: Tausende Immobilien erfolgreich verkauft, jeden Werktag mindestens eine Immobilie.\nKomplettes Team: 40 Experten (Marketing, Aufbereitung, Telefonservice, Abwicklung) arbeiten für Sie.\nProfessionelle Vermarktung: Hochwertige Innen-, Außen- und Luftaufnahmen, Lifestyle-Exposé im Zeitschriftenstil.\nKein vertraglicher Zwang: Keine Exklusivität, keine Laufzeit, Sie können privat weiterverkaufen. Jederzeit kündbar mit einem Anruf – wir tragen alle Kosten bis dahin.\nRisikofreie Zusammenarbeit: Wir gehen auf unser Risiko und in Vorleistung, bezahlt werden wir nur bei erfolgreichem Verkauf und wenn der Kaufpreis  der für Sie verbleibt Sie zufriedenstellt.\n",
         antworten: [],
      },
      position: {
         x: 2000,
         y: 26650,
      },
   },
   f0_14: {
      id: "f0_14",
      type: "buttonNode",
      data: {
         frage: "1. Kurzvorstellung von BAUR Immobilien:\nSpezialisiert auf die Vereinfachung und Absicherung des Verkaufsprozesses\nVon der rechtssicheren Aufbereitung der Unterlagen über die zielgruppengerichtete Vermarktung bis zur erfolgreichen Abwicklung des Verkaufs\nEin mehr als 40-köpfiges Team aus Experten (Marketing, Aufbereitung, Telefonservice, Abwicklung) arbeitet für Sie\n<br/>\n2. Unsere Dienstleistungen:\nDirekte Ansprache unserer bestehenden Kunden\nZielgruppengerichtete Vermarktung mit hochwertigem Exposé (Innen-, Außen-, und Luftaufnahmen)\nExposé erstellt von unserer Grafikabteilung und professionell gedruckt in unserer hauseigenen Druckerei\nAusschreibung auf relevanten Plattformen – auf unsere Kosten\n<br/>\n3. Zusatzleistungen hervorheben:\nKoordination der Besichtigungen, Verhandlungen in Ihrem Namen\nBonitätsprüfung der Käufer\nKaufvertrag in Absprache, mit Haftungsausschlüssen und Unterstützung bis zur Beurkundung\n<br/>\n4. Risikofreie Zusammenarbeit:\nKeine vertragliche Bindung, keine Laufzeit\nWeiterhin Privatverkauf möglich\nWir gehen auf unser Risiko und tragen alle Kosten bis zur erfolgreichen Vermittlung\nWenn Sie die Zusammenarbeit stoppen möchten, geht das täglich per Anruf. Alle bisherigen Kosten tragen wir.\n<br/>\n5. Marktwertermittlung Ihrer Immobilie und Marktbericht Ihres Quartiers:\nKostenfreie, aktualisierte Marktwertermittlung Ihrer Immobilie\nZusätzlich ein Marktbericht für Ihr Quartier, den Sie ideal als Unterstützung für Ihren Verkauf nutzen können – auch wenn Sie keine Zusammenarbeit wünschen oder diese beenden.\n<br/>\n6. Erfolgsbasierte Bezahlung:\nNur Bezahlung bei erfolgreichem Verkauf, wenn Sie mit dem Kaufpreis zufrieden sind, der Ihnen nach Abzug aller Kosten verbleibt\nWir tragen alle Kosten bei nicht erfolgreicher Vermittlung\n<br/>\n7. Abschlussfrage:\n„Klingt das nach einer Unterstützung, die für Sie interessant wäre?“\n",
         antworten: [],
      },
      position: {
         x: 2000,
         y: 28700,
      },
   },
};

export const allEdges = [
   {
      id: "terminfalse0",
      source: "termin",
      sourceHandle: "handle_termin_0",
      target: false,
   },
   {
      id: "unterlagenfalse0",
      source: "unterlagen",
      sourceHandle: "handle_unterlagen_0",
      target: false,
   },
   {
      id: "f0f0_00",
      source: "f0",
      sourceHandle: "handle_f0_0",
      target: "f0_0",
   },
   {
      id: "f0f0_11",
      source: "f0",
      sourceHandle: "handle_f0_1",
      target: "f0_1",
   },
   {
      id: "f0f0_22",
      source: "f0",
      sourceHandle: "handle_f0_2",
      target: "f0_2",
   },
   {
      id: "f0f0_33",
      source: "f0",
      sourceHandle: "handle_f0_3",
      target: "f0_3",
   },
   {
      id: "f0f0_44",
      source: "f0",
      sourceHandle: "handle_f0_4",
      target: "f0_4",
   },
   {
      id: "f0f0_55",
      source: "f0",
      sourceHandle: "handle_f0_5",
      target: "f0_5",
   },
   {
      id: "f0f0_66",
      source: "f0",
      sourceHandle: "handle_f0_6",
      target: "f0_6",
   },
   {
      id: "f0f0_77",
      source: "f0",
      sourceHandle: "handle_f0_7",
      target: "f0_7",
   },
   {
      id: "f0f0_88",
      source: "f0",
      sourceHandle: "handle_f0_8",
      target: "f0_8",
   },
   {
      id: "f0f0_99",
      source: "f0",
      sourceHandle: "handle_f0_9",
      target: "f0_9",
   },
   {
      id: "f0f0_1010",
      source: "f0",
      sourceHandle: "handle_f0_10",
      target: "f0_10",
   },
   {
      id: "f0f0_1111",
      source: "f0",
      sourceHandle: "handle_f0_11",
      target: "f0_11",
   },
   {
      id: "f0f0_1212",
      source: "f0",
      sourceHandle: "handle_f0_12",
      target: "f0_12",
   },
   {
      id: "f0f0_1313",
      source: "f0",
      sourceHandle: "handle_f0_13",
      target: "f0_13",
   },
   {
      id: "f0f0_1414",
      source: "f0",
      sourceHandle: "handle_f0_14",
      target: "f0_14",
   },
   {
      id: "f0_0f0_0_00",
      source: "f0_0",
      sourceHandle: "handle_f0_0_0",
      target: "f0_0_0",
   },
   {
      id: "f0_0_0termin0",
      source: "f0_0_0",
      sourceHandle: "handle_f0_0_0_0",
      target: "termin",
   },
   {
      id: "f0_0_0unterlagen1",
      source: "f0_0_0",
      sourceHandle: "handle_f0_0_0_1",
      target: "unterlagen",
   },
   {
      id: "f0_1f0_1_00",
      source: "f0_1",
      sourceHandle: "handle_f0_1_0",
      target: "f0_1_0",
   },
   {
      id: "f0_1_0unterlagen0",
      source: "f0_1_0",
      sourceHandle: "handle_f0_1_0_0",
      target: "unterlagen",
   },
   {
      id: "f0_1_0termin1",
      source: "f0_1_0",
      sourceHandle: "handle_f0_1_0_1",
      target: "termin",
   },
   {
      id: "f0_2f0_2_00",
      source: "f0_2",
      sourceHandle: "handle_f0_2_0",
      target: "f0_2_0",
   },
   {
      id: "f0_2f0_2_11",
      source: "f0_2",
      sourceHandle: "handle_f0_2_1",
      target: "f0_2_1",
   },
   {
      id: "f0_2unterlagen2",
      source: "f0_2",
      sourceHandle: "handle_f0_2_2",
      target: "unterlagen",
   },
   {
      id: "f0_2f0_2_33",
      source: "f0_2",
      sourceHandle: "handle_f0_2_3",
      target: "f0_2_3",
   },
   {
      id: "f0_2_0f0_2_0_00",
      source: "f0_2_0",
      sourceHandle: "handle_f0_2_0_0",
      target: "f0_2_0_0",
   },
   {
      id: "f0_2_0f0_2_0_11",
      source: "f0_2_0",
      sourceHandle: "handle_f0_2_0_1",
      target: "f0_2_0_1",
   },
   {
      id: "f0_2_0_0termin0",
      source: "f0_2_0_0",
      sourceHandle: "handle_f0_2_0_0_0",
      target: "termin",
   },
   {
      id: "f0_2_0_1unterlagen0",
      source: "f0_2_0_1",
      sourceHandle: "handle_f0_2_0_1_0",
      target: "unterlagen",
   },
   {
      id: "f0_2_1f0_2_1_00",
      source: "f0_2_1",
      sourceHandle: "handle_f0_2_1_0",
      target: "f0_2_1_0",
   },
   {
      id: "f0_2_1_0f0_2_1_0_00",
      source: "f0_2_1_0",
      sourceHandle: "handle_f0_2_1_0_0",
      target: "f0_2_1_0_0",
   },
   {
      id: "f0_2_1_0unterlagen1",
      source: "f0_2_1_0",
      sourceHandle: "handle_f0_2_1_0_1",
      target: "unterlagen",
   },
   {
      id: "f0_2_1_0_0unterlagen0",
      source: "f0_2_1_0_0",
      sourceHandle: "handle_f0_2_1_0_0_0",
      target: "unterlagen",
   },
   {
      id: "f0_2_1_0_0termin1",
      source: "f0_2_1_0_0",
      sourceHandle: "handle_f0_2_1_0_0_1",
      target: "termin",
   },
   {
      id: "f0_2_3f0_2_3_00",
      source: "f0_2_3",
      sourceHandle: "handle_f0_2_3_0",
      target: "f0_2_3_0",
   },
   {
      id: "f0_2_3f0_2_3_11",
      source: "f0_2_3",
      sourceHandle: "handle_f0_2_3_1",
      target: "f0_2_3_1",
   },
   {
      id: "f0_2_3_0unterlagen0",
      source: "f0_2_3_0",
      sourceHandle: "handle_f0_2_3_0_0",
      target: "unterlagen",
   },
   {
      id: "f0_2_3_0f0_2_3_0_01",
      source: "f0_2_3_0",
      sourceHandle: "handle_f0_2_3_0_1",
      target: "f0_2_3_0_0",
   },
   {
      id: "f0_2_3_0_0f0_2_3_0_0_00",
      source: "f0_2_3_0_0",
      sourceHandle: "handle_f0_2_3_0_0_0",
      target: "f0_2_3_0_0_0",
   },
   {
      id: "f0_2_3_0_0_0unterlagen0",
      source: "f0_2_3_0_0_0",
      sourceHandle: "handle_f0_2_3_0_0_0_0",
      target: "unterlagen",
   },
   {
      id: "f0_2_3_0_0_0unterlagen1",
      source: "f0_2_3_0_0_0",
      sourceHandle: "handle_f0_2_3_0_0_0_1",
      target: "unterlagen",
   },
   {
      id: "f0_2_3_1f0_2_3_1_00",
      source: "f0_2_3_1",
      sourceHandle: "handle_f0_2_3_1_0",
      target: "f0_2_3_1_0",
   },
   {
      id: "f0_2_3_1f0_2_3_1_11",
      source: "f0_2_3_1",
      sourceHandle: "handle_f0_2_3_1_1",
      target: "f0_2_3_1_1",
   },
   {
      id: "f0_2_3_1unterlagen2",
      source: "f0_2_3_1",
      sourceHandle: "handle_f0_2_3_1_2",
      target: "unterlagen",
   },
   {
      id: "f0_2_3_1unterlagen3",
      source: "f0_2_3_1",
      sourceHandle: "handle_f0_2_3_1_3",
      target: "unterlagen",
   },
   {
      id: "f0_2_3_1_0f0_2_3_0_0_00",
      source: "f0_2_3_1_0",
      sourceHandle: "handle_f0_2_3_1_0_0",
      target: "f0_2_3_0_0_0",
   },
   {
      id: "f0_2_3_1_1f0_2_3_0_0_00",
      source: "f0_2_3_1_1",
      sourceHandle: "handle_f0_2_3_1_1_0",
      target: "f0_2_3_0_0_0",
   },
   {
      id: "f0_3unterlagen0",
      source: "f0_3",
      sourceHandle: "handle_f0_3_0",
      target: "unterlagen",
   },
   {
      id: "f0_3f0_2_31",
      source: "f0_3",
      sourceHandle: "handle_f0_3_1",
      target: "f0_2_3",
   },
   {
      id: "f0_3f0_3_02",
      source: "f0_3",
      sourceHandle: "handle_f0_3_2",
      target: "f0_3_0",
   },
   {
      id: "f0_3_0termin0",
      source: "f0_3_0",
      sourceHandle: "handle_f0_3_0_0",
      target: "termin",
   },
   {
      id: "f0_3_0unterlagen1",
      source: "f0_3_0",
      sourceHandle: "handle_f0_3_0_1",
      target: "unterlagen",
   },
   {
      id: "f0_4f0_4_00",
      source: "f0_4",
      sourceHandle: "handle_f0_4_0",
      target: "f0_4_0",
   },
   {
      id: "f0_4_0termin0",
      source: "f0_4_0",
      sourceHandle: "handle_f0_4_0_0",
      target: "termin",
   },
   {
      id: "f0_4_0f0_1",
      source: "f0_4_0",
      sourceHandle: "handle_f0_4_0_1",
      target: "f0_",
   },
   {
      id: "f0_5absage0",
      source: "f0_5",
      sourceHandle: "handle_f0_5_0",
      target: "absage",
   },
   {
      id: "f0_5f0_61",
      source: "f0_5",
      sourceHandle: "handle_f0_5_1",
      target: "f0_6",
   },
   {
      id: "f0_6f0_6_00",
      source: "f0_6",
      sourceHandle: "handle_f0_6_0",
      target: "f0_6_0",
   },
   {
      id: "f0_6termin1",
      source: "f0_6",
      sourceHandle: "handle_f0_6_1",
      target: "termin",
   },
   {
      id: "f0_6_0termin0",
      source: "f0_6_0",
      sourceHandle: "handle_f0_6_0_0",
      target: "termin",
   },
   {
      id: "f0_6_0f0_8_0_01",
      source: "f0_6_0",
      sourceHandle: "handle_f0_6_0_1",
      target: "f0_8_0_0",
   },
   {
      id: "f0_7f0_6_00",
      source: "f0_7",
      sourceHandle: "handle_f0_7_0",
      target: "f0_6_0",
   },
   {
      id: "f0_7termin1",
      source: "f0_7",
      sourceHandle: "handle_f0_7_1",
      target: "termin",
   },
   {
      id: "f0_8termin0",
      source: "f0_8",
      sourceHandle: "handle_f0_8_0",
      target: "termin",
   },
   {
      id: "f0_8f0_8_01",
      source: "f0_8",
      sourceHandle: "handle_f0_8_1",
      target: "f0_8_0",
   },
   {
      id: "f0_8_0f0_8_0_00",
      source: "f0_8_0",
      sourceHandle: "handle_f0_8_0_0",
      target: "f0_8_0_0",
   },
   {
      id: "f0_8_0_0unterlagen0",
      source: "f0_8_0_0",
      sourceHandle: "handle_f0_8_0_0_0",
      target: "unterlagen",
   },
   {
      id: "f0_8_0_0absage1",
      source: "f0_8_0_0",
      sourceHandle: "handle_f0_8_0_0_1",
      target: "absage",
   },
   {
      id: "f0_9f0_9_00",
      source: "f0_9",
      sourceHandle: "handle_f0_9_0",
      target: "f0_9_0",
   },
   {
      id: "f0_9_0unterlagen0",
      source: "f0_9_0",
      sourceHandle: "handle_f0_9_0_0",
      target: "unterlagen",
   },
   {
      id: "f0_9_0absage1",
      source: "f0_9_0",
      sourceHandle: "handle_f0_9_0_1",
      target: "absage",
   },
   {
      id: "f0_10termin0",
      source: "f0_10",
      sourceHandle: "handle_f0_10_0",
      target: "termin",
   },
   {
      id: "f0_10f0_10_01",
      source: "f0_10",
      sourceHandle: "handle_f0_10_1",
      target: "f0_10_0",
   },
   {
      id: "f0_10_0termin0",
      source: "f0_10_0",
      sourceHandle: "handle_f0_10_0_0",
      target: "termin",
   },
   {
      id: "f0_10_0unterlagen1",
      source: "f0_10_0",
      sourceHandle: "handle_f0_10_0_1",
      target: "unterlagen",
   },
   {
      id: "f0_11unterlagen0",
      source: "f0_11",
      sourceHandle: "handle_f0_11_0",
      target: "unterlagen",
   },
   {
      id: "f0_11f0_11_01",
      source: "f0_11",
      sourceHandle: "handle_f0_11_1",
      target: "f0_11_0",
   },
   {
      id: "f0_11_0termin0",
      source: "f0_11_0",
      sourceHandle: "handle_f0_11_0_0",
      target: "termin",
   },
   {
      id: "f0_11_0unterlagen1",
      source: "f0_11_0",
      sourceHandle: "handle_f0_11_0_1",
      target: "unterlagen",
   },
   {
      id: "f0_12f00",
      source: "f0_12",
      sourceHandle: "handle_f0_12_0",
      target: "f0",
   },
];
